<template>
  <div>
    <div class="bet-table">

      <div class="col-12">
        <h1>Pontszámok</h1>
      </div>

      <div class="col-12">
        <table class="table table-striped" v-if="scores.length > 0">
          <thead>
            <tr>
              <th scope="col">Fogadó neve</th>
              <th scope="col">Összpontszám</th>
              <th scope="col">Alappontszám</th>
              <th scope="col">Gólarány</th>
              <th scope="col">Győztes</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="score in scores" :key="score.id">
              <td ><span>{{ score.name }}</span></td>
              <td class="font-weight-bold">{{ score.score_total }}</td>
              <td >{{ score.score_total-(score.score_goals_rate + score.score_winner)}}</td>
              <td>{{ score.score_goals_rate }}</td>
              <td>{{ score.score_winner }}</td>
            </tr>
          </tbody>
        </table>
          <h1 v-else class="text-center padding-bottom--small">Még nem ért véget az első meccs!</h1>
      </div>
    </div>
  </div>
</template>

<script>
// import ApiHandler from "@/mixins/apiHandlerMI";
import viewMI from "@/mixins/viewMI";

export default {
  data() {
    return {
      forms: {},
      editMessage: false,
      scores: [],      
    }
  },
  mixins: [viewMI],
  components: {},
  // mounted() {
  //   this.getScores();
  // },  
  methods: {
    userReady(){
      this.getScores();
    },
    getScores() {
      const _this = this;

      this.get('score', {},
          function (response) {
            // console.log(response)
            if (response.data.status === true){
              _this.scores = response.data.scores;
            }                        
          }, function (error) {
            //error
            console.log('getScores error', error)

          }
      )
    },
  }
}
</script>
